import { render, staticRenderFns } from "./template-work-order-lots.html?vue&type=template&id=2e37b79e&scoped=true&"
import script from "./template-work-order-lots.js?vue&type=script&lang=js&"
export * from "./template-work-order-lots.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37b79e",
  null
  
)

export default component.exports